<template>
  <div class="mate-stic">
    <div class="mate-head">
      <div style="width: 80%;text-align: left;">
        <el-page-header @back="goBack" content="等待处理" style="margin-right:1vw;"></el-page-header>
        <!-- <span>申请人：</span>
              <el-input placeholder="请输入申请人" v-model="search.applicant" clearable></el-input>
              <span style="margin-left:1vw;">采购类型：</span>
              <el-select v-model="search.purchaseType" clearable placeholder="请选择">
                  <el-option
                    v-for="item in typeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
              </el-select>
              <span style="margin-left:1vw;">月份：</span>
              <el-date-picker v-model="search.createDate" type="month" value-format="yyyy-MM" clearable placeholder="选择月份"></el-date-picker>
              <el-button type="primary" style="margin-left:1vw;" @click="doFilter">查询</el-button> -->
      </div>

    </div>
    <div class="mate-head">
      <div style="width: 100%;text-align: left;">
        <span >工程名称:</span>
        <el-input placeholder="请输入工程名称" v-model="search.programmeName" clearable></el-input>
        <span style="margin-left: 10px;">审批单编号:</span>
        <el-input placeholder="请输入审批单编号" v-model="search.orderNumber" clearable></el-input>
        <span style="margin-left: 10px;">审批单内容:</span>
        <el-input placeholder="请输入审批单内容" v-model="search.contentInfo" clearable></el-input>
        <span style="margin-left: 10px;">审批单类型:</span>
        <el-select v-model="search.processType" placeholder="请选择" @input="change($event)" clearable filterable>
          <el-option v-for="item in seasupList" :key="item.id" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" style="margin-left:1vw;" @click="doFilter">查询</el-button>
      </div>
      <!-- <el-button  type="danger" icon="el-icon-delete" plain style="margin-left:1vw;" @click="doFilter">删除</el-button>
        <el-button  type="primary" icon="el-icon-check" plain style="margin-left:1vw;" @click="doFilter">提交</el-button>
        <el-button  type="primary" icon="el-icon-refresh-left" plain  style="margin-left:1vw;" @click="doFilter">退回</el-button> -->

    </div>
    <div class="mate-main">
      <el-table stripe :data="listData" height="100%" style="width: 100%;" border
        :header-cell-style="{background:'#F5F7F9',color:'#909399'}" @selection-change="handleSelectionChange">
        <!-- <el-table-column type="selection" width="55">
        </el-table-column> -->
        <template slot="empty">
          <p>{{dataText}}</p>
        </template>
        <el-table-column label="序号" width="100">
          <template slot-scope="scope">
            <a>{{ (scope.$index+1)+(currentPage-1)*pageSize}}</a>
          </template>
        </el-table-column>
        <el-table-column label="审批单类型" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.processTypeName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="工程名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.programmeName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="审批单内容" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.contentInfo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="编号" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.orderNumber}}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请人">
          <template slot-scope="scope">
            <span>{{scope.row.createBy}}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请时间">
          <template slot-scope="scope">
            <span>{{scope.row.createDate}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="备注">
          <template slot-scope="scope">
            <span>{{scope.row.remark}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="状态" prop="createDate">
          <template slot-scope="scope">
            <div @click="proccess(scope.$index, scope.row)" style="cursor: pointer;">
              <div style="color: #f00;" v-if="scope.row.processStatus<=scope.row.processCount">待{{scope.row.unitName}}
              </div>
              <div style="color: #f00;" v-if="scope.row.processStatus<=scope.row.processCount">
                ({{scope.row.postName}})审批</div>
              <span style="color: #1aa034;" v-if="scope.row.processStatus>scope.row.processCount">已完成</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width=200>
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row,2)">详情</el-button>
            <el-button type="text" v-if="scope.row.operatePower==2" size="mini" @click="check(scope.$index, scope.row)">审核
            </el-button>
            <el-button type="text" v-if="scope.row.operatePower==1&&scope.row.isOwn==1" size="mini" @click="sumbit(scope.$index, scope.row)">
              提交</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <!-- <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
          ></el-pagination> -->
    </div>
    <!-- 新增窗口 -->
    <el-dialog :title="dialogTitle" :visible.sync="addFormVisible" center :append-to-body="true" :lock-scroll="false"
      class="add-form" width="1000px">
      <el-form :model="addForm" ref="addForm" :rules="rules" label-width="160px" :label-position="labelPosition">
        <!-- <el-form-item label="采购申请单号：" prop="orderNumber">
              <el-input v-if="addForm.purchaseId==''" v-model="addForm.orderNumber" autocomplete="off">
                  <el-button slot="append" @click="createCode">生成编号</el-button>
              </el-input>
              <span v-else>{{addForm.orderNumber}}</span>
          </el-form-item> -->
        <el-form-item  v-for="item in fromData" :key="item.purchaseId" :label="item.name"   >
          
          <div v-for="(item1,index) in fileList" :key="index"  v-if="item.name =='附件'"
              style="width: 100%;display: flex;align-items: center;font-size: 10px;">
              <img @click="showFile(item1.fileUrl)" style="width:25px;cursor: pointer;"
                src="../../assets/image/fileicon.png" alt="">
              <span>{{item1.pdfname}}</span>
              <!-- <i @click="deletePdf(item,index)" style="color: #f00;margin-left: 20px;cursor: pointer;" class="el-icon-delete"></i> -->
          </div>
           <!-- 表格 -->
           <el-table :data="tableData" height="350px" style="width: 100%;font-size: 12px;" v-if="item.name =='工程签证审批汇总表明细'">
            <el-table-column label="序号">
              <template slot-scope="scope">
                <span>{{scope.$index+1}}</span>
              </template>
            </el-table-column>
            <el-table-column label="签证编号" prop="createDate">
              <template slot-scope="scope">
                <span>{{scope.row.编号}}</span>
              </template>
            </el-table-column>
            <el-table-column label="签证内容" prop="createDate">
              <template slot-scope="scope">
                <span>{{scope.row.签证内容}}</span>
              </template>
            </el-table-column>
            <el-table-column label="签证金额" prop="createDate">
              <template slot-scope="scope">
                <span>{{scope.row.签证金额}}</span>
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="createDate">
              <template slot-scope="scope">
                <span>{{scope.row.备注}}</span>
              </template>
            </el-table-column>    
          </el-table>  
          <!-- 工程形象进度表明细 -->
          <el-table :data="tableData1" height="350px" style="width: 100%;font-size: 12px;" v-if="item.name =='工程形象进度表明细'">
            <el-table-column label="序号" width=80>
              <template slot-scope="scope">
                <span>{{scope.$index+1}}</span>
              </template>
            </el-table-column>
            <el-table-column label="工程名称" prop="createDate">
              <template slot-scope="scope">
                <span>{{scope.row.工程名称}}</span>
              </template>
            </el-table-column>
            <el-table-column label="截止本月末累计完成情况" prop="createDate">
              <template slot-scope="scope">
                <span>{{scope.row.截止本月末累计完成情况}}</span>
              </template>
            </el-table-column>
            <el-table-column label="本月完成情况" prop="createDate">
              <template slot-scope="scope">
                <span>{{scope.row.本月完成情况}}</span>     
              </template>        
            </el-table-column>
          </el-table>
          <el-input :title="item.content"
            v-if="item.name =='验收内容'||item.name =='申请内容'||item.name=='测算的变更金额' ||item.name=='工程联系单内容'||item.name=='备注'" type="textarea"
            maxlength="200" show-word-limit :rows="4" v-model="item.content" autocomplete="off" disabled>
          </el-input>
          <div v-if="item.name =='现场签证'||item.name =='设计变更' ||item.name =='一类变更'||item.name =='二类变更：设计疏漏'||item.name =='二类变更：设计优化'||item.name =='二类变更：被动变更'">
            <el-checkbox v-model="item.content" disabled></el-checkbox>
          </div>
          <el-input :title="item.content"
            v-if="item.name !='附件'&&item.name !='工程形象进度表明细' &&item.name !='工程签证审批汇总表明细'&&item.name !='验收内容'&&item.name !='申请内容'&&item.name!='测算的变更金额'&&item.name!='现场签证'&&item.name!='设计变更' && item.name!='工程联系单内容'&& item.name!='备注' 
            &&item.name !='一类变更' &&item.name !='二类变更：设计疏漏'&&item.name !='二类变更：设计优化'&&item.name !='二类变更：被动变更'"
            v-model="item.content" autocomplete="off" disabled>
          </el-input>
        </el-form-item>
      </el-form>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
      </div> -->
    </el-dialog>
    <!-- 提交批阅内容 -->
    <el-dialog :title="sbumitTitle" :visible.sync="sbumitVisible" center :append-to-body="true"
      :before-close="handleClosesbumit" :lock-scroll="false" width="35%">
      <el-form :model="sbumitForm" ref="sbumitForm" label-width="200px" :label-position="labelPosition">
        <el-form-item label="提交备注:">
          <el-input v-model="sbumitForm.remark" type="textarea" autocomplete="off" placeholder="请输入提交备注"
            style="width:90%" maxlength="600" show-word-limit :rows="16"></el-input>
        </el-form-item>
        <el-form-item label="附件:">
          <el-upload class="avatar-uploader" :action="uploadUrl" :headers="uploadHead" :data="uploadData"
            :before-remove="beforeRemove" :on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload"
            :show-file-list="false" :on-preview="showFile" ref="upload1" :file-list="fileListupload1">
            <!-- <div v-if="pdfUrl"  class="avatar">{{pdfUrl}}</div> -->
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <!-- <img  v-if="addForm.reportAppendix"  @click="showFile" style="width:50px;cursor: pointer;"  src="../../assets/image/pdf.png" alt="">
<span v-if="addForm.reportAppendix">{{pdfname}}</span> -->
          <!-- 循環多個文件 -->
          <div v-for="(item,index) in fileList1" :key="index"
            style="width: 100%;display: flex;align-items: center;font-size: 10px;">
            <img @click="showFile(item.fileUrl)" style="width:25px;cursor: pointer;"
              src="../../assets/image/fileicon.png" alt="">
            <span>{{item.pdfname}}</span>
            <i @click="deletePdf(item,index,fileList1,2)" style="color: #f00;margin-left: 20px;cursor: pointer;"
              class="el-icon-delete"></i>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sbumitVisible = false">取 消</el-button>
        <el-button type="primary" @click="sbumitAddRow2('sbumitForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 审核弹框 -->
    <el-dialog :title="checkTitle" :visible.sync="checkVisible" center :append-to-body="true"
      :before-close="handleClosecheck" :lock-scroll="false" width="35%">
      <el-form :model="checkForm" ref="checkForm" label-width="200px" :label-position="labelPosition">
        <el-form-item label="审核:">
          <el-radio v-model="checkForm.checkStatus" label="1">通过</el-radio>
          <el-radio v-model="checkForm.checkStatus" label="2">不通过</el-radio>
        </el-form-item>
        <el-form-item label="提交备注:">
          <el-input v-model="checkForm.remark" type="textarea" autocomplete="off" placeholder="请输入提交备注"
            style="width:90%" maxlength="600" show-word-limit :rows="16"></el-input>
        </el-form-item>
        <el-form-item label="附件:">
          <el-upload class="avatar-uploader" :action="uploadUrl" :headers="uploadHead" :data="uploadData"
            :before-remove="beforeRemove" :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload"
            :show-file-list="false" :on-preview="showFile" ref="upload2" :file-list="fileListupload2">
            <!-- <div v-if="pdfUrl"  class="avatar">{{pdfUrl}}</div> -->
            <i class="el-icon-plus avatar-uploader-icon"></i>

          </el-upload>
          <!-- <img  v-if="addForm.reportAppendix"  @click="showFile" style="width:50px;cursor: pointer;"  src="../../assets/image/pdf.png" alt="">
<span v-if="addForm.reportAppendix">{{pdfname}}</span> -->
          <!-- 循環多個文件 -->
          <div v-for="(item,index) in fileList2" :key="index"
            style="width: 100%;display: flex;align-items: center;font-size: 10px;">
            <img @click="showFile(item.fileUrl)" style="width:25px;cursor: pointer;"
              src="../../assets/image/fileicon.png" alt="">
            <span>{{item.pdfname}}</span>
            <i @click="deletePdf(item,index,fileList2,3)" style="color: #f00;margin-left: 20px;cursor: pointer;"
              class="el-icon-delete"></i>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkVisible = false">取 消</el-button>
        <el-button type="primary" @click="checkAddRow2('checkForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 审批流弹框 -->
    <el-dialog :title="processTitle" :visible.sync="processVisible" center :append-to-body="true"
      :before-close="handleCloseprocess" :lock-scroll="false" width="35%" height="700px">
      <div style="height: 350px;overflow: auto;">
        <el-steps direction="vertical">
          <el-step v-for="(item,index) in processList" :key="index" process-status="success">
            <template slot="description">
              <div>
                <div class="stepNoBtn">
                  <div class="step-title-font">处理人:{{ item.createBy }}({{item.unitName}}--{{item.postName}})</div>
                  <div class="step-title-font">处理时间:{{ item.createDate }}</div>
                  <div>处理意见：{{item.remark||'无'}}</div>
                  <div v-if="item.appendix" style="display: flex;align-items: center;">
                    <span>附件：</span>
                    <img @click="showFile(item.appendix)" style="width:25px;cursor: pointer;"
                      src="../../assets/image/fileicon.png" alt="">
                  </div>
                </div>
              </div>
            </template>
          </el-step>
        </el-steps>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import myHttp from '../../untils/port'
  import util from '../../untils/util'
  import base from '../../untils/base'
  export default {
    data() {
      return {
        groupId: '',
        search: {
          programmeName: '',
          orderNumber: '',
          processType: '',
          contentInfo:''
        },
        listData: [],
        dataText: '数据加载中...',
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        //弹出框
        addFormVisible: false,
        addForm: {
          purchaseId: '',
          purchaseName: '',
          materialSpec: '',
          unit: '',
          unitAmount: '',
          supplyTime: '',
          processStatus: '',
          supplierId: '',
          productId: ''
        },
        dialogTitle: '',
        rules: {
          unitAmount: [{ required: true, message: '请输入采购数量', trigger: 'blur' }],
          purchaseName: [{ required: true, message: '请输入采购名称', trigger: 'blur' }],
          purchaseId: [{ required: true, message: '请选择项目', trigger: 'change' }],
        },
        labelPosition: 'right',
        typeList: [],//发票类型
        isAddFlag: false,
        multipleSelection: [],
        processStatus: '',
        supList: [],//供应商列表
        productList: [],//产品名称列表
        proList: [],//项目列表
        backVisible: false,
        backTitle: '退回原因',
        backForm: {

        },
        sbumitTitle: '提交',
        sbumitVisible: false,
        sbumitForm: {
          linkId: '',
          remark: '',
        },
        checkTitle: '审核',
        checkVisible: false,
        checkForm: {
          linkId: '',
          checkStatus: '',
          remark: '',
        },
        processTitle: '审批流程',
        processVisible: false,
        processForm: {

        },
        processList: [],
        uploadUrl: base.url + '/common/uploadFile', //上传地址
        uploadHead: {
          accessToken: util.session.get('token'),
        },
        uploadUrl: base.url + '/upload/uploadFile', //上传地址
        uploadData: {
          type: '247',
          projectId: ''
        },
        uploadHead: {
          //上传接口header
          accessToken: this.$store.state.token
        },
        fileList: [],
        fileList1: [],
        fileList2: [],
        fileListupload: [],
        fileListupload1: [],
        fileListupload2: [],
        seasupList: [],
        fromData:[],
        tableData:[],
        tableData1:[],
      }
    },
    mounted() {
      var role= util.session.get('roleId');
      if(role==4){
        this.search.groupType =2
      }else if(role==5){
        this.search.groupType =1
      }
      this.groupId = util.session.get('groupId')
      // this.addForm.processStatus = this.processStatus
      this.uploadData.projectId = this.projectId
      // this.getPro()
      // this.getSup()
      this.getData()
      this.getTree()
      // console.log(this.processStatus)
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getData()
      },
      // 监控当前页码
      currentChangePage() {
        this.getData()
      },
      //查询
      doFilter() {
        this.currentPage = 1
        this.getData()
      },
      //获取数据
      getData() {
        var that = this
        this.search.groupId = this.groupId
        this.search.processStatus = this.processStatus
        // this.search.pageSize = this.pageSize
        // this.search.pageNum = this.currentPage
        myHttp.spTableLinkWaitDoList(this.search).then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].visible = false
            }
            that.listData = list
            if (list.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.dataText = '暂无数据'
          }
        })
      },
      // 查询供应商
      getSup() {
        var that = this
        .findSpTableInformationList({
          groupId :  this.groupId,
           groupType: this.search.groupType
        }).then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data
            that.supList = list
            that.seasupList = list
          }
        })
      },
      //获取采购类型
      getPiaoType() {
        var that = this
        myHttp.getDictByType({
          type: 'purchase_type'
        }).then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.dictList || []
            that.typeList = list
          }
        })
      },
      //获取名称
      getNameByType(id) {
        var list = this.typeList
        var result = ''
        for (var i = 0; i < list.length; i++) {
          if (id == list[i].value) {
            result = list[i].label
          }
        }
        return result
      },
      // 获取项目列表
      getPro() {
        var that = this
        myHttp.selectCompanyPurchaseList({
          groupId: this.groupId
        }).then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data
            // console.log(list)
            that.proList = list
          }
        })
      },
      //添加
      addFun() {
        // if (this.isAddFlag) {
        //     this.$message.warning('请先保存当前台账')
        //     return
        //   } else if (this.master.id != '') {
        //     this.$message.warning('请先保存当前编辑项')
        //     return
        //   }
        this.isAddFlag = true
        this.addFormVisible = true
        this.dialogTitle = '添加明细'
        this.addForm.purchaseId = ''
        this.addForm.recordId = ''
        this.addForm.purchaseName = ''
        this.addForm.materialSpec = ''
        this.addForm.unit = ''
        this.addForm.unitAmount = ''
        this.addForm.supplyTime = ''
        this.addForm.supplierId = ''
        this.addForm.productId = ''
      },
      //编辑
      handleEdit(index, row) {
        // this.getSup()
        // this.floorSel(row.supplierId)
        this.fromData = []
        this.addFormVisible = true
        // this.addForm.recordId = row.recordId
        // this.addForm.purchaseName = row.purchaseName
        // this.addForm.materialSpec = row.materialSpec
        // this.addForm.unit = row.unit
        // this.addForm.unitAmount = row.unitAmount
        // this.addForm.supplyTime = row.supplyTime
        // this.addForm.supplierId = row.supplierId
        // this.addForm.productId = row.productId
        var that = this
        myHttp.spTableLinkDetail({
          processType: row.processType,
          linkId: row.linkId,
          groupId : this.groupId,
          groupType:this.search.groupType
        }).then(function (resp) {
          if (resp.data.code == '200') {
            var data = resp.data.data.detailData
            // console.log(data)
            for (let key in data) {
                //将遍历出的对象和属性转换成数组，push到数组中
                that.fromData.push({
                  name: key,
                  content:data[key],
                });
              }
              console.log(that.fromData)
             for(var i = 0 ;i<that.fromData.length;i++){
               if(that.fromData[i].name=='附件'){
                that.addForm.appendix = that.fromData[i].content
               }
               if(that.fromData[i].name=='工程签证审批汇总表明细'){
                that.tableData = that.fromData[i].content
 
               }
               if(that.fromData[i].name=='工程形象进度表明细'){
                that.tableData1 = that.fromData[i].content
                console.log(that.tableData1)
               }
               if (that.fromData[i].name == '现场签证' || that.fromData[i].name == '设计变更'|| that.fromData[i].name == '一类变更'|| that.fromData[i].name == '二类变更：设计疏漏'|| that.fromData[i].name == '二类变更：设计优化'|| that.fromData[i].name == '二类变更：被动变更') {
                that.fromData[i].content = that.fromData[i].content == 1 ? true : false
              }


             } 
            console.log(that.addForm.appendix)
            if( that.addForm.appendix){
              let array = [];
              let list = that.addForm.appendix.split(',')
              // console.log(list)
              list.map((item, index) => {
                array.push(
                  Object.assign({}, { fileUrl: item })
                )
              });
              if (array.length != 0) {
                for (var i = 0; i < array.length; i++) {
                  // array[i].response.data.fileUrl = array[i].fileUrl 
                  array[i].nameArr = array[i].fileUrl.split('/')
                  array[i].pdfname = array[i].nameArr[array[i].nameArr.length - 1]
                }
              }
              console.log(array)
              that.fileList = array
            }
          }
        })
      },
      //提交
      sumbitAddRow(formName) {
        var that = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (that.addForm.recordId == "") {
              myHttp.addCompanyPurchaseRecord(this.addForm).then(function (resp) {
                if (resp.data.code == "200") {
                  that.$message.success("添加成功");
                  that.addFormVisible = false;
                  // that.currentPage = 1;
                  that.getData();
                  setTimeout(window.location.reload(), 2000)

                } else {
                  that.$message.error(resp.data.msg);
                }
              }, function () { });
            } else {
              myHttp.editCompanyPurchaseRecord(this.addForm).then(function (resp) {
                if (resp.data.code == "200") {
                  that.$message.success("修改成功");
                  that.addFormVisible = false;
                  that.getData();
                } else {
                  that.$message.error(resp.data.msg);
                }
              }, function () { });
            }
          }
        });
      },
      backAddRow2(formName) {
        var that = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.backForm.processStatus = parseInt(this.processStatus) - 1
            myHttp.returnCompanyPurchaseRecord(this.backForm).then(function (resp) {
              if (resp.data.code == "200") {
                that.$message.success(resp.data.msg);
                that.backVisible = false
                that.getData();
              } else {
                that.$message.error(resp.data.msg);
              }
            }, function () { });
          }
        });
      },
      //删除
      handleDelete(index, row) {
        var that = this;
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteCompanyPurchase({
            purchaseId: row.purchaseId
          }).then(function (resp) {
            if (resp.data.code == "200") {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.getData();
            } else {
              that.$message.error(resp.data.msg);
            }
          }, function () { });
        }).catch(err => {

        })
      },
      handleClosesbumit() {
        this.sbumitVisible = false
      },
      handleCloseback() {
        this.backVisible = false
      },
      handleCloseprocess() {
        this.processVisible = false
      },
      //查看明细
      toDetail(row) {
        this.$router.push({ path: '/materDetail/' + row.purchaseId + '/' + row.orderNumber })
      },
      //生成编号
      createCode() {
        var str = this.randomString(8)
        this.addForm.orderNumber = 'MT' + str
      },
      randomString(len, charSet) {
        charSet = charSet || '0123456789'
        var randomString = ''
        for (var i = 0; i < len; i++) {
          var randomPoz = Math.floor(Math.random() * charSet.length)
          randomString += charSet.substring(randomPoz, randomPoz + 1)
        }
        return randomString
      },
      // 返回上一页
      goBack() {
        this.$router.go(-1)
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 批量删除
      someDelete(index, row) {
        var that = this;
        // var multipleSelection = this.multipleSelection
        // if (multipleSelection.length == '0') {
        //   that.$message({
        //     type: 'warning',
        //     message: '请选择需要删除的数据!'
        //   })
        //   return
        // }

        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteCompanyPurchaseRecord({
            recordId: row.recordId
          }).then(function (resp) {
            if (resp.data.code == "200") {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.getData();
            } else {
              that.$message.error(resp.data.msg);
            }
          }, function () { });
        }).catch(err => {
        })
      },
      // 批量退回
      withDraw(index, row) {
        var that = this;
        // var multipleSelection = this.multipleSelection
        // if (multipleSelection.length == '0') {
        //   that.$message({
        //     type: 'warning',
        //     message: '请选择需要退回的数据!'
        //   })
        //   return
        // }

        this.$confirm('此操作将永久退回该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.recallCompanyPurchaseRecord({
            recordId: row.recordId
          }).then(function (resp) {
            if (resp.data.code == "200") {
              that.$message({
                type: 'success',
                message: '退回成功'
              })
              that.getData();
            } else {
              that.$message.error(resp.data.msg);
            }
          }, function () { });
        }).catch(err => {
        })
      },
      // 退回上一级
      withBack(index, row) {
        this.backVisible = true
        this.backForm.recordId = row.recordId

        // this.$confirm('此操作将该数据退回上一级, 是否继续?', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   myHttp.recallCompanyPurchaseRecord({
        //     recordId: row.recordId
        //   }).then(function (resp) {
        //     if (resp.data.code == "200") {
        //       that.$message({
        //         type: 'success',
        //         message: '退回成功'
        //       })
        //       that.getData();
        //     } else {
        //       that.$message.error(resp.data.msg);
        //     }
        //   }, function () { });
        // }).catch(err => {
        // })



      },
      // 确定提交
      sbumitAddRow2(formName) {
        var that = this
        var picUrls = []
        var that = this
        if (this.fileList1.length > 0) {
          for (var i = 0; i < this.fileList1.length; i++) {
            picUrls.push(this.fileList1[i].response.data.fileUrl)
          }
          this.sbumitForm.appendix = picUrls.toString()
        }

        this.$refs[formName].validate((valid) => {
          if (valid) {
            // this.sbumitForm.processType = this.processType
            // this.sbumitForm.processStatus =this.processStatus
            this.sbumitForm.groupId =this.groupId
            this.sbumitForm.groupType =this.search.groupType
            this.sbumitForm.projectId = this.search.projectId
            
            myHttp.submitSpTableLink(this.sbumitForm).then(function (resp) {
              if (resp.data.code == "200") {
                that.$message.success(resp.data.msg);
                that.sbumitVisible = false
                that.getData();
              } else {
                that.$message.error(resp.data.msg);
              }
            }, function () { });
          }
        });
      },
      // 批量提交
      sumbit(index, row) {
        var that = this;
        // var multipleSelection = this.multipleSelection
        // if (multipleSelection.length == '0') {
        //   that.$message({
        //     type: 'warning',
        //     message: '请选择需要退回的数据!'
        //   })
        //   return
        // }
        this.sbumitForm.linkId = row.linkId
        this.sbumitForm.processType = row.processType
        this.sbumitForm.processStatus = row.processStatus
        this.sbumitVisible = true

        // this.$confirm('此操作将提交该数据, 是否继续?', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   myHttp.submitCompanyPurchaseRecord({
        //     recordId: row.recordId,
        //     processStatus: parseInt(this.processStatus) + 1
        //   }).then(function (resp) {
        //     if (resp.data.code == "200") {
        //       that.$message({
        //         type: 'success',
        //         message: '提交成功'
        //       })
        //       that.getData();
        //     } else {
        //       that.$message.error(resp.data.msg);
        //     }
        //   }, function () { });
        // }).catch(err => {
        // })
      },
      // 同意支付
      argee(index, row, checkStatus) {
        var that = this;
        var checkStatusname = checkStatus == 1 ? '同意支付 ' : '不同意支付 '
        this.$confirm(' 是否' + checkStatusname + '?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.checkCompanyPurchaseRecord({
            recordId: row.recordId,
            checkStatus: checkStatus
          }).then(function (resp) {
            if (resp.data.code == "200") {
              that.$message({
                type: 'success',
                message: '提交成功'
              })
              that.getData();
            } else {
              that.$message.error(resp.data.msg);
            }
          }, function () { });
        }).catch(err => {
        })
      },
      //监听供应商下拉框
      floorSel(e) {
        this.doFilter()
        this.getSup()
        for (var i = 0; i < this.supList.length; i++) {
          if (e == this.supList[i].supplierId) {
            // console.log(i)
            this.productList = this.supList[i].companySupplierProductList
          }
        }
      },
      //监听供应商下拉框清空
      floorClear() {
        this.supList = []
        this.productList = []
        this.addForm.supplierId = ''
        this.addForm.productId = ''
        this.doFilter()
      },
      intoReason(index, row) {
        this.reasonVisible = true
        this.reasonForm.returnReason = row.returnReason
      },
      // 
      change(e) {
        this.$forceUpdate()
      },
      handleClosereason() {
        this.$forceUpdate()
        this.reasonVisible = false
      },
      proccess(index, row) {
        this.processVisible = true
        this.processForm.linkId = row.linkId
        this.processForm.processType = row.processType
        this.processForm.projectId = this.search.projectId
        this.getProcess()
      },
      //获取流程
      getProcess() {
        var that = this
        myHttp.findSpTableLinkRecord(this.processForm).then(function (resp) {
          if (resp.data.code == "200") {
            var list = resp.data.data
            that.processList = list
          } else {
            that.$message.error(resp.data.msg);
          }
        }, function () { });
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
      handleIconSuccess(res, file, opt, other) {
        if (res.code == '200') {
          console.log(opt)
          console.log(res)
          this.fileList = opt
          // var picUrls =[]
          // for(var i=0;i<opt.length;i++){
          //   picUrls.push(opt[i].response.data.saveUrls)
          // }
          // console.log(picUrls)
        } else {
          this.$message.error(res.msg)
        }
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
      handleRemove(file, fileList) {
        console.log(fileList)
        this.fileList = fileList
      },
      // 
      getTree() {
        var that = this
        myHttp
        .findSpTableInformationList({
          groupId :  this.groupId,
           groupType: this.search.groupType
        })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.seasupList = resp.data.data
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      },
      showFile(file) {
        // console.log(this.addForm.reportAppendix)
        window.open(base.httpCtx + file)
      },

      beforeAvatarUpload(file) {

        const isPDF = file.type === 'application/pdf';
        // const isLt2M = file.size / 1024 / 1024 < 2;
        console.log(file.type)
        // if (!isPDF) {
        //   this.$message.error('附件只能是 pdf 格式!');
        // } else {
        this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        // }
        // if (!isLt2M) {
        //   this.$message.error('上传头像图片大小不能超过 2MB!');
        // }
        // return isPDF;
      },
      beforeRemove(file, fileList) {
        var that = this
        // return this.$confirm(`确定移除 ${ file.name }？` ,{
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() =>{
        //   console.log(that.fileList)
        // });
      },
      handleAvatarSuccess(res, file, fileList) {
        // console.log(fileList)
        // this.fileList = []
        this.$forceUpdate();
        if (res.code == '200') {
          this.$message.success(res.msg)
          this.loading.close();
          if (fileList.length != 0) {
            for (var i = 0; i < fileList.length; i++) {
              fileList[i].fileUrl = fileList[i].response.data.fileUrl
              fileList[i].nameArr = fileList[i].response.data.fileUrl.split('/')
              fileList[i].pdfname = fileList[i].nameArr[fileList[i].nameArr.length - 1]
            }
          }
          if (this.dialogTitle == '添加') {
            this.fileList = fileList
          } else {
            this.fileList = this.fileList.concat(fileList)
          }

          console.log(this.fileList)
        } else {
          // this.loading.close()
          this.$message.error(res.msg)
        }
      },
      // 提交附件
      handleAvatarSuccess1(res, file, fileList) {
        // console.log(fileList)
        // this.fileList = []
        this.$forceUpdate();
        if (res.code == '200') {
          this.$message.success(res.msg)
          this.loading.close();
          if (fileList.length != 0) {
            for (var i = 0; i < fileList.length; i++) {
              fileList[i].fileUrl = fileList[i].response.data.fileUrl
              fileList[i].nameArr = fileList[i].response.data.fileUrl.split('/')
              fileList[i].pdfname = fileList[i].nameArr[fileList[i].nameArr.length - 1]
            }
          }
          this.fileList1 = fileList
          console.log(this.fileList1)
        } else {
          // this.loading.close()
          this.$message.error(res.msg)
        }

      },
      //审批附件
      handleAvatarSuccess2(res, file, fileList) {
        // console.log(fileList)
        // this.fileList = []
        this.$forceUpdate();
        if (res.code == '200') {
          this.$message.success(res.msg)
          this.loading.close();
          if (fileList.length != 0) {
            for (var i = 0; i < fileList.length; i++) {
              fileList[i].fileUrl = fileList[i].response.data.fileUrl
              fileList[i].nameArr = fileList[i].response.data.fileUrl.split('/')
              fileList[i].pdfname = fileList[i].nameArr[fileList[i].nameArr.length - 1]
            }
          }
          this.fileList2 = fileList
          console.log(this.fileList2)
        } else {
          // this.loading.close()
          this.$message.error(res.msg)
        }

      },
      check(index, row) {
        var that = this;
        this.fileList2 = []
        this.checkForm.checkStatus = ''
        this.checkForm.remark = ''
        this.checkForm.linkId = row.linkId
        this.checkForm.processStatus = row.processStatus
        this.checkForm.processType = row.processType
        this.checkVisible = true
        this.$nextTick(() => {
          this.$refs.upload2.clearFiles()
        });

      },
      checkAddRow2(formName) {
        var that = this
        var picUrls = []
        var that = this
        if (this.fileList2.length > 0) {
          for (var i = 0; i < this.fileList2.length; i++) {
            picUrls.push(this.fileList2[i].response.data.fileUrl)
          }
          this.checkForm.appendix = picUrls.toString()
        }

        this.$refs[formName].validate((valid) => {
          if (valid) {
            // this.checkForm.processType = this.processType
            // this.sbumitForm.processStatus =this.processStatus
            this.checkForm.projectId = this.search.projectId
            this.checkForm.groupId =this.groupId
            this.checkForm.groupType =this.search.groupType
            myHttp.checkSpTableLink(this.checkForm).then(function (resp) {
              if (resp.data.code == "200") {
                that.$message.success(resp.data.msg);
                that.checkVisible = false
                that.getData();
              } else {
                that.$message.error(resp.data.msg);
              }
            }, function () { });
          }
        });
      },
      handleClosecheck() {
        this.checkVisible = false
      },
      // 删除文件
      deletePdf(item, index, fileList, type) {
        console.log(item, index, fileList)
        return this.$confirm(`确定移除 ${item.pdfname}？`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          fileList.splice(index, 1);
          switch (type) {
            case 1:
              this.fileList = fileList
            case 2:
              this.fileList1 = fileList
            case 3:
              this.fileList2 = fileList
          }
        });
      },

   
    }
  }
</script>

<style scoped>
  .mate-stic {
    width: 100%;
    height: 100%;
    position: relative;
    padding: 1vh;
    overflow: auto;
  }

  .title-crumb {
    width: 100%;
    height: 4vh;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    padding-left: 1vw;
  }

  .mate-head {
    width: 100%;
    height: 8vh;
    position: relative;
    background: #fff;
    padding: 2vh 1vw 1vh;
    display: flex;
    /* justify-content: flex-start;
      justify-items: flex-start; */
    justify-content: space-between;
    align-content: center;
    align-items: center;
    border-bottom: 5px solid #ecf0f5;
  }

  /* .mate-head-left{
      width: 7vw;
      position: relative;
      text-align: right;
      padding: 1vh 0;
  }
  .mate-head-r{
      width: calc( 100% - 10vw );
      position: relative;
      height: 5vh;
      overflow: hidden;
  }
  .mate-head-r.showAll{
      height: auto;
  }
  .mate-head-r-item{
      width: auto;
      position: relative;
      margin-right: 2vh;
      display: flex;
      align-items: center;
      float: left;
      margin-bottom: 1vh;
      cursor: pointer;
      color: #3E50B4;
      padding: 1vh 1vw;
      border-radius: 5px;
  }
  .mate-head-r-item:hover{
      background: #0490F9;
      color: #fff;
  }
  .mate-head-r-item.cur{
      background: #0490F9;
      color: #fff;
  }
  .mate-head-bottom{
      width: 3vw;
      display: flex;
      justify-items: flex-end;
      align-items: flex-end;
      min-height: 5vh;
      padding-bottom: 1vh;
      cursor: pointer;
  } */
  .stepNoBtn {
    color: #303133;
    height: 110px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px;
  }

  .mate-main {
    width: 100%;
    height: calc(100% - 17vh);
    position: relative;
  }

  .color1 {
    color: #f00;
  }

  .color2 {
    color: #0caf18;
  }

  .color3 {
    color: #36a6f2;
  }
</style>

<style>

</style>